import React, { useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import {
  customerByEmailMini,
  userByEmailMini,
} from "../../../graphql/reloadyard/custom-queries";
import { SaveButton, useNotify, useRedirect } from "react-admin";
import { useForm } from "react-final-form";

import { logError } from "../../../utils/appUtils";
import { UserStatus } from "../../../utils/constants";

import { emailInviteHTML } from "./emailInviteHTML";
import { emailWelcomeBackHTML } from "./emailWelcomeBackHTML";
import { updateUserMini } from "../../../graphql/reloadyard/custom-mutations";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const fetchDuplicateRecords = async (email) => {
  try {
    const [customerResponse, userResponse] = await Promise.all([
      API.graphql(graphqlOperation(customerByEmailMini, { email })),
      API.graphql(graphqlOperation(userByEmailMini, { email })),
    ]);
    return { customerResponse, userResponse };
  } catch (error) {
    logError("users:ValidateSaveButton:fetchDuplicateRecords", error, false);
    throw error;
  }
};

const handleDuplicateUser = async (dbUser, user) => {
  try {
    let toUpdateUser = {
      ...dbUser,
      ...user,
      active: true,
    };
    // if (!user?.acl) {
    //   toUpdateUser.acl = []
    // }
    delete toUpdateUser.cognitoId;

    const updatedUser = await API.graphql(
      graphqlOperation(updateUserMini, { input: toUpdateUser })
    );
    return updatedUser?.data?.updateUser;
  } catch (err) {
    logError(
      "managerApp:customers:ValidateSaveButton:handleDuplicateUser",
      err,
      false
    );
  }
  return null;
};

const validateEmailUniqueness = async (user) => {
  if (user) {
    try {
      const { customerResponse, userResponse } = await fetchDuplicateRecords(
        user.email
      );

      const duplicateCustomer =
        customerResponse.data.customerByEmail.items.length > 0;
      const duplicateUser = userResponse.data.userByEmail.items.length > 0;

      if (duplicateUser || duplicateCustomer) {
        const dbUser = userResponse.data.userByEmail.items[0];
        if (dbUser?.active === "true" || duplicateCustomer) {
          return { message: `User with this email already exists.` };
        } else {
          if (dbUser.reloadYardId === window.appUser.reloadYardId) {
            return await handleDuplicateUser(dbUser, user);
          } else {
            return {
              message: `Cannot reactivate a user in different reload Yard`,
            };
          }
        }
      }
    } catch (error) {
      logError(
        "users:ValidateSaveButton:validateEmailUniqueness",
        error,
        false
      );
    }
  }
  return null;
};

export const ValidateSaveButton = (props) => {
  const classes = useStyles();
  const form = useForm();
  const notify = useNotify();
  const redirect = useRedirect();
  const [isSaving, setIsSaving] = useState(false);
  const { basePath } = props;

  const handleValidateSave = async () => {
    const formState = form.getState();
    const formData = formState.values;
    const isValid = !formState.invalid; // Form-level validation status. Submit to force field-level form validation.
    setIsSaving(true);

    if (isValid) {
      const isDuplicate = await validateEmailUniqueness(formData);
      if (isDuplicate?.id) {
        // re-activaqted user
        await onSuccess({ data: formData }, true);
        setIsSaving(false);
        return;
      } else if (isDuplicate) {
        // errror message
        notify(isDuplicate.message, "error");
        setIsSaving(false);
        return;
      }
    } else {
      setIsSaving(false);
    }

    handleSave(); // submit and force field-level form validation whether valid or not.
  };

  const handleSave = () => {
    props.handleSubmitWithRedirect(); // submit and force field-level form validation whether valid or not.
  };

  const transform = (data) => {
    data = { ...data };
    debugger;

    try {
      data.active = "true";
      data.status = UserStatus.PENDING_REG;
      data.reloadYardId = window.appUser.reloadYardId;
      data.groups = window.appUser.groups;

      data.fullName = `${data.firstName} ${data.lastName}`;
      data.email = data.email.toLowerCase();

      // must have - boundedTextField does not transform to upper case
      if (data.address?.state)
        data.address.state = data.address.state.toUpperCase();
      if (data.address?.zipCode)
        data.address.zipCode = data.address.zipCode.toUpperCase();
      delete data.address?.name;
    } catch (error) {
      logError("users:ValidateSaveButton:transform", error, notify);
      return Promise.reject();
    }

    return data;
  };

  const onSuccess = async ({ data }, isReactivated = false) => {
    debugger;
    try {
      const emailContent = isReactivated
        ? emailWelcomeBackHTML(
            data.firstName,
            data.email,
            window.appUser?.firstName,
            window.appUser?.reloadYard.name
          )
        : emailInviteHTML(
            data.firstName,
            data.email,
            window.appUser?.firstName,
            window.appUser?.reloadYard.name
          );

      const emailSubject = isReactivated
        ? "Welcome Back to transloads.co!"
        : "Your transloads.co Invite Is Waiting";

      try {
        const response = await API.post("transREST", "/sendEmail", {
          body: {
            to: data.email,
            bcc: ["support@transloads.co"],
            subject: emailSubject,
            template: "emailTemplate.html",
            htmlContent: emailContent,
          },
        });

        if (response.error) {
          throw response.error;
        } else {
          notify(`User created successfully.`);
          redirect("list", basePath);
        }
      } catch (error) {
        logError("users:UserEmailError", error, false);
      }
    } catch (error) {
      logError("users:ValidateSaveButton:onSuccess", error, notify);
    } finally {
      setIsSaving(false);
    }
  };

  const onFailure = (error) => {
    setIsSaving(false);
    logError("users:ValidateSaveButton:onFailure", error, notify);
  };

  return (
    <>
      <SaveButton
        {...props}
        submitOnEnter={false}
        undoable={false}
        saving={isSaving}
        handleSubmitWithRedirect={handleValidateSave}
        transform={transform}
        onSuccess={onSuccess}
        onFailure={onFailure}
      />
      <Backdrop className={classes.backdrop} open={isSaving}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};
